import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    userReactionDetails: {
      requesting: false,
      error: null,
      success: false,
      data: [],
    },
  };

export const userReactionSlice = createSlice({
  name: 'userReaction',
  initialState,
  reducers: {
    getUserReactionDetails: (state) => {
        state.userReactionDetails.requesting = true;
        state.userReactionDetails.error = null;
        state.userReactionDetails.data = null;
        state.userReactionDetails.success = false; 
    },
    getUserReactionDetailsSuccess: (state, action) => {
        state.userReactionDetails.requesting = false;
        state.userReactionDetails.data = action.payload;
        state.userReactionDetails.success = true; 
    },
    getUserReactionDetailsFail: (state, action) => {        
        state.userReactionDetails.requesting = false;
        state.userReactionDetails.error = action.payload;
    },
    doUserReactionCreate: (state) => {
      state.userReactionDetails.requesting = true;
      state.userReactionDetails.error = null;
      state.userReactionDetails.data = null;
      state.userReactionDetails.success = false; 
    },
    doUserReactionUpdate: (state) => {
      state.userReactionDetails.requesting = true;
      state.userReactionDetails.error = null;
      state.userReactionDetails.data = null;
      state.userReactionDetails.success = false; 
    },
    doUserReactionDelete: (state) => {
      state.userReactionDetails.requesting = true;
      state.userReactionDetails.error = null;
      state.userReactionDetails.data = null;
      state.userReactionDetails.success = false; 
    },
  },
})

export const { 
  doUserReactionCreate, doUserReactionUpdate, doUserReactionDelete,
  getUserReactionDetails, getUserReactionDetailsSuccess, getUserReactionDetailsFail,
} = userReactionSlice.actions

export default userReactionSlice.reducer